var AsideCounters = function ($scope = $document) {

	var $target = $scope.find('.aside-counters');

	if (!$target.length) {
		return;
	}

	var $counter = $scope.find('.js-counter');

	$counter.each(function () {

		new Counter($(this));

	});

}
